var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-p-4 tw-text-center"},[_c('div',{staticClass:"tw-inline-block"},[_c('div',{staticClass:"tw-flex tw-items-center"},[_c('div',{staticClass:"tw-mr-1.5"},[_vm._t("icon")],2),_vm._v(" "),_c('div',[_vm._t("count")],2)])]),_vm._v(" "),_c('div',{staticClass:"tw-mt-1 tw-text-xs tw-text-gray-500"},[_vm._t("title")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }